import type { GA4Item, GA4ItemInput } from "./types";

export function buildGA4Item(input: GA4ItemInput): GA4Item {
  const item: GA4Item = {
    item_id: input.itemId,
    item_name: input.itemName,
    currency: "USD",
  };

  if (input.priceCents != null) {
    item.price = Math.round(input.priceCents) / 100;
  }
  if (input.quantity != null) item.quantity = input.quantity;
  if (input.category) item.item_category = input.category;
  if (input.variant) item.item_variant = input.variant;
  if (input.index != null) item.index = input.index;
  if (input.listId) item.item_list_id = input.listId;
  if (input.listName) item.item_list_name = input.listName;

  return item;
}

export function buildGA4ItemsFromCart(
  items: Array<{
    productId: string;
    productTitle: string;
    unitPriceCents: number;
    quantity: number;
    productTypeSlug?: string;
  }>,
): GA4Item[] {
  return items.map((item, index) =>
    buildGA4Item({
      itemId: item.productId,
      itemName: item.productTitle,
      priceCents: item.unitPriceCents,
      quantity: item.quantity,
      category: item.productTypeSlug,
      index,
    }),
  );
}
